import React from 'react';
import "./Splash.css"

const Splash = () => {
  return (
    <div id="splash">
      <img src="/images/logo2.png" alt="Logo" id="splash-logo" />
    </div>
  );
};

export default Splash;